export default {
    PENDING: 'pending',
    FAILED: 'failed',
    RESOLVED: 'resolved',
};
